import store from '@/store';
import {snapshot} from "valtio";


export const getCompanyId = () => {
    const {currentUser} = snapshot(store)
    return currentUser?.selectedCompany?.id
    /*const authString = Cookies.get('auth');
    let searchParams;


    if (typeof window !== 'undefined') {
        const url = new URL(window.location.href);
        searchParams = url.searchParams;
    } else {
        return null;
    }

    if (!authString) {
        return null;
    }


    const authObject = authString ? JSON.parse(authString) : {};
    const {companies, selectedCompanyId = null, companyNames} = authObject;
    const storeName = searchParams.get("storeName") ?? sessionStorage.getItem('storeName')
    const selectedCompany = companyNames.length > 0 ? companyNames.find((c: { store_name: string | null; }) => c.store_name === storeName) : null
    let currentCompanyId = selectedCompany?.id
    store.selectedCompanyId=selectedCompany?.id
    sessionStorage.setItem('companyId', currentCompanyId)
    sessionStorage.setItem('storeName', storeName??"")
    return currentCompanyId*/
}
